import { Button, Stack, Tooltip, useTranslate } from '@prenuvo/halo';

import { FctDialog } from '@/shared/ui';

import { getAddendumModeTooltipKey } from './study-mode-dialog.util';
import { useStudyModeDialog } from './use-study-mode-dialog.hook';

export function StudyModeDialog() {
  const {
    canEnterAddendum,
    hasActiveSession,
    isCurrentUserSession,
    isEnteringAddendum,
    isLoading,
    isOpen,
    onEnterMode,
    onExit,
  } = useStudyModeDialog();

  const translate = useTranslate();

  const addendumTooltip = translate(
    getAddendumModeTooltipKey({
      canEnterAddendum,
      hasActiveSession,
      isCurrentUserSession,
    }),
  );

  if (isOpen) {
    return (
      <FctDialog onOpenChange={() => {}} open title="FCT.ADDENDUM.STUDY_MODE_DIALOG.TITLE">
        <div className="w-full">
          <Stack alignment="center" gap={3} isWrapped justification="between">
            <Button
              className={{ root: 'min-w-35 justify-center' }}
              disabled={isEnteringAddendum}
              onClick={onExit}
              size="sm"
              translationKey="FCT.ADDENDUM.STUDY_MODE_DIALOG.EXIT"
              variant="outlined"
            />
            <Stack gap={3} isWrapped>
              <Tooltip content={addendumTooltip} delayDuration={120} side="bottom">
                <span>
                  <Button
                    className={{ root: 'min-w-35 justify-center' }}
                    disabled={!canEnterAddendum || isLoading || isEnteringAddendum}
                    onClick={() => onEnterMode('addendum')}
                    size="sm"
                    translationKey="FCT.ADDENDUM.STUDY_MODE_DIALOG.ADDENDUM_MODE"
                    variant="outlined"
                  />
                </span>
              </Tooltip>

              <Tooltip
                content={translate('FCT.ADDENDUM.STUDY_MODE_DIALOG.TOOLTIP.READ_ONLY_MODE')}
                delayDuration={120}
                side="bottom"
              >
                <span>
                  <Button
                    className={{ root: 'min-w-35 justify-center' }}
                    disabled={isEnteringAddendum}
                    onClick={() => onEnterMode('read-only')}
                    size="sm"
                    translationKey="FCT.ADDENDUM.STUDY_MODE_DIALOG.READ_ONLY_MODE"
                    variant="primary"
                  />
                </span>
              </Tooltip>
            </Stack>
          </Stack>
        </div>
      </FctDialog>
    );
  }

  return null;
}
